import React from 'react'
import './localStyles.css'

export default function Statuses({  statuses, uploaded, total }) {

  console.log('Statuses render', statuses)
  const activeCount = Object.keys(statuses).length
  const remaining = total - (uploaded + activeCount)

  return (
    <div className="slow-fade-in">
      {Object.entries(statuses).map(([k, v]) => (
        <div key={k}>
          <label className="bold padding-right-1">{k}</label>
          <span>{Math.round(v.progress)}%</span>
        </div>
      ))}
      {remaining > 0 && (
        <div style={{ marginTop: '1rem', color: '#666', fontStyle: 'italic' }}>
          + {remaining} more files in queue...
        </div>
      )}
      <div style={{ marginTop: '0.5rem', fontSize: '0.8rem', borderTop: '1px solid #ccc', paddingTop: '0.5rem' }}>
        Total Progress: {uploaded + activeCount} / {total}
      </div>
    </div>
  )
}
